import { Validators } from '@angular/forms';
import { HandleCleanUp } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/commands/handle-clean-up.command.service';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { HandleRemainingBalanceCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/handle-remaining-balance-validation.command';
import { SetProjectPropertiesCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/set-project-properties.command';
import { ApplicationOptionLoader } from '@ordersnproducts/modules/order-builder/modules/specification/services/loaders/application-option-loader.service';
import { SpacingOptionLoader } from '@ordersnproducts/modules/order-builder/modules/specification/services/loaders/spacing-option-loader.service';
import { UnloadTimeOptionLoader } from '@ordersnproducts/modules/order-builder/modules/specification/services/loaders/unload-time-option-loader.service';
import { UNITS } from '@ordersnproducts/modules/shared/constants/units';
import { FormInfoMessageComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-info-message/form-info-message.component';
import { FormInputCheckboxComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-checkbox/form-input-checkbox.component';
import { FormInputNumberComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-number/form-input-number.component';
import {
  FieldConfig,
  NewLineField,
} from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldInputNumberConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-number-config.interface';
import { FieldLabelConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-label-config.interface';
import { FormSelectComponent } from '../../../../../../../shared/modules/configurable-form/components/form-select/form-select.component';
import { FieldSelectConfig } from '../../../../../../../shared/modules/configurable-form/components/form-select/models/field-select-config.interface';
import { RmsContractProductsEffects } from '../../../../effects/contract-products.effects';
import { generateAddedValueFormName } from '../../../../helpers/form-added-value-name-generator';
import { AddedValueFieldConfig } from '../../../../models/form-added-value-field-config';
import { RmsFormConfig } from '../../../../models/rms-form-config';
import { AddedValueDisabler } from '../../../../providers/added-value-enabler.provider';
import { ContractProductsDisabler } from '../../../../providers/contract-product-enabler.provider';
import { PumpAvailability } from '../../../../providers/pump-availabe.provider';
import { RmsMaximumCapacityProvider } from '../../../../providers/rms-maximum-capacity.provider';
import {
  LoadChildAddedValues,
  LoadProductAddedValues,
} from '../../../../services/config-loader/commands/load-added-value.command.service';
import { LoadContractBalance } from '../../../../services/config-loader/commands/load-contract-balance.command.service';
import { ResetCatalogsCommand } from '../../../../services/config-loader/commands/reset-catalogs.command.service';
import { RmsHandleMaximumCapacity } from '../../../../services/config-loader/commands/rms-handle-max-capacity.command';
import { SetPaymentTermCommand } from '../../../../services/config-loader/commands/set-contract-payment.command.service';
import { AdddedValuesLoaderService } from '../../../../services/config-loader/loaders/added-value.loader.service';
import { PaymentTermsOptionLoaderService } from '../../../../services/config-loader/loaders/contract-payment-term-loader.service';
import { ContractProductsOptionLoaderService } from '../../../../services/config-loader/loaders/contract-products.loader.service';
import { ContractsOptionLoaderService } from '../../../../services/config-loader/loaders/contract.loader.service';
import { PumpableProjectProfilesOptionLoader } from '../../../../services/config-loader/loaders/pumpable-project-profile.service.loader';
import { PumpableUnloadTypeOptionLoader } from '../../../../services/config-loader/loaders/pumpable-unload-type.loader.service';
import { FormTextAreaComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-textarea/form-textarea.component';
import { FormInfoIconMessageComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-info-icon-message/form-info-icon-message.component';
import { CutOffEffects } from '../../../../effects/cut-off.effects';
import { LoadCatalogs } from '../../../../services/config-loader/commands/catalogs.command.service';
import { HandlePumpCapacityCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/handle-pump-capacity.command';
import { PumpLengthOptionLoader } from '@ordersnproducts/modules/order-builder/modules/specification/services/loaders/pump-length-option-loader.service';
import { PumpApiOptionLoader } from '@ordersnproducts/modules/order-builder/modules/specification/services/loaders/pump-with-api-option-loader.service';
import { HandlePumpWithLinearMetersCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/handle-pump-linear-meters.command';
import { HandleLinearMeterChangeCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/handle-linear-meter-change.command';
import { FormInputComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input/form-input.component';
import { ContractFormSelectShowToggle } from '../../../../providers/contract-form-field.op.enabler.provider';
import { SpecFieldTestIds } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-test-ids.enum';

export const rmsLegacy = {
  recipe: [
    {
      type: FormInputComponent,
      label: 'id',
      name: SpecFieldNames.ID,
      containerClassNames: ['d-none'],
      placeholder: 'id',
    } as FieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.product_description',
      name: SpecFieldNames.PRODUCT_SELECTION,
      dataTId: SpecFieldTestIds.PRODUCT_DESCRIPTION,
      containerClassNames: ['field-12x field-md-6x retail-control'],
      optionsLoader: ContractProductsOptionLoaderService,
      loading: ContractProductsDisabler.IsLoading,
      validation: [Validators.required],
      dynamicEffects: [RmsContractProductsEffects, CutOffEffects],
      placeholder: 'views.specifications.select_product',
      onChange: [LoadContractBalance, LoadProductAddedValues, ResetCatalogsCommand, LoadCatalogs],
      rehydrate: true,
    } as FieldSelectConfig,
    {
      type: FormInputNumberComponent,
      label: 'views.specifications.quantity',
      containerClassNames: ['field-6x field-md-2x retail-control'],
      name: SpecFieldNames.QUANTITY,
      dataTId: SpecFieldTestIds.QUANTITY,
      min: 1,
      value: 1,
      step: 1,
      max: RmsMaximumCapacityProvider.RmsMaxCapacity,
      message: RmsMaximumCapacityProvider.Message,
      suffix: UNITS.CUBIC_METERS,
      validation: [Validators.required],
      decimals: 1,
      onChange: [HandleRemainingBalanceCommand],
    } as FieldInputNumberConfig,
    {
      type: FormInfoIconMessageComponent,
      name: SpecFieldNames.CONCRETE_MIN_QUANTITY_INFO,
      dataTId: SpecFieldTestIds.CONCRETE_MIN_QUANTITY_INFO,
      value: false,
      containerClassNames: ['field-4x field-md-1x retail-control'],
      text: 'views.specifications.concrete_min_quantity',
    } as FieldConfig,
    {
      type: FormInputCheckboxComponent,
      name: SpecFieldNames.ADJUSTMENT,
      dataTId: SpecFieldTestIds.ADJUSTMENT,
      value: false,
      containerClassNames: ['field-1x field-md-2x retail-control '],
      placeholder: 'views.specifications.Adjustment',
    } as FieldConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormInfoMessageComponent,
      name: SpecFieldNames.PRODUCT_PUMP_INFORMATIVE,
      dataTId: SpecFieldTestIds.PRODUCT_PUMP_INFORMATIVE,
      containerClassNames: ['field-12x field-md-6x'],
      text: 'views.specifications.pumping_not_available',
      hidden: PumpAvailability.ShouldHide,
    } as FieldLabelConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.contract',
      name: SpecFieldNames.CONTRACT_SELECT,
      dataTId: SpecFieldTestIds.CONTRACT_SELECT,
      containerClassNames: ['field-12x field-md-6x retail-control'],
      visible: ContractFormSelectShowToggle.EnableContractToggleFlag,
      optionsLoader: ContractsOptionLoaderService,
      validation: [Validators.required],
      placeholder: 'views.specifications.select_contract',
      onChange: [SetPaymentTermCommand, RmsHandleMaximumCapacity],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(0),
      dataTId: SpecFieldTestIds.VALUE_ADDED_FIRST,
      index: 0,
      loading: AddedValueDisabler.IsLoading,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      optionsLoader: AdddedValuesLoaderService,
      onChange: [LoadChildAddedValues],
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(1),
      dataTId: SpecFieldTestIds.VALUE_ADDED_SECOND,
      index: 1,
      loading: AddedValueDisabler.IsLoading,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      onChange: [LoadChildAddedValues],
      optionsLoader: AdddedValuesLoaderService,
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(2),
      dataTId: SpecFieldTestIds.VALUE_ADDED_THIRD,
      index: 2,
      loading: AddedValueDisabler.IsLoading,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      onChange: [LoadChildAddedValues],
      optionsLoader: AdddedValuesLoaderService,
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.valueAdded',
      name: generateAddedValueFormName(3),
      dataTId: SpecFieldTestIds.VALUE_ADDED_FOURTH,
      index: 3,
      loading: AddedValueDisabler.IsLoading,
      limit: true,
      optionsLoader: AdddedValuesLoaderService,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_valueAdded',
      rehydrate: true,
    } as AddedValueFieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.paymentTerms',
      name: SpecFieldNames.PAYMENT_TERMS,
      dataTId: SpecFieldTestIds.PAYMENT_TERMS,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      disabled: true,
      optionsLoader: PaymentTermsOptionLoaderService,
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.project_profiles',
      name: SpecFieldNames.PROJECT_PROFILES,
      dataTId: SpecFieldTestIds.PROJECT_PROFILES,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_projectProfiles',
      optionsLoader: PumpableProjectProfilesOptionLoader,
      onChange: [SetProjectPropertiesCommand],
    } as FieldSelectConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.unload_type',
      name: SpecFieldNames.UNLOAD_TYPE,
      dataTId: SpecFieldTestIds.UNLOAD_TYPE,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_unloadType',
      optionsLoader: PumpableUnloadTypeOptionLoader,
      onChange: [HandlePumpWithLinearMetersCommand, HandleCleanUp],
      validation: [Validators.required],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.pump_capacity',
      name: SpecFieldNames.PUMP,
      dataTId: SpecFieldTestIds.PUMP_CAPACITY,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_pumpCapacity',
      onChange: [HandlePumpCapacityCommand],
      optionsLoader: PumpApiOptionLoader,
      validation: [Validators.required],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.pump_length',
      name: SpecFieldNames.PUMP_LENGTH,
      dataTId: SpecFieldTestIds.PUMP_LENGTH,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_pumpLength',
      hidden: true,
      optionsLoader: PumpLengthOptionLoader,
      validation: [Validators.required],
    } as FieldSelectConfig,
    {
      type: FormInputNumberComponent,
      label: 'views.specifications.pipes',
      containerClassNames: ['field-12x field-md-2x retail-control'],
      name: SpecFieldNames.PIPE_QUANTITY,
      dataTId: SpecFieldTestIds.PIPE_QUANTITY,
      min: 0,
      value: 0,
      step: 1,
    } as FieldInputNumberConfig,
    {
      type: FormInputNumberComponent,
      label: 'views.specifications.hoses',
      containerClassNames: ['field-12x field-md-2x retail-control'],
      name: SpecFieldNames.HOSES,
      dataTId: SpecFieldTestIds.HOSES,
      min: 0,
      value: 0,
      step: 1,
    } as FieldInputNumberConfig,
    {
      type: FormInputNumberComponent,
      label: 'views.specifications.linear_meters',
      containerClassNames: ['field-12x field-md-2x retail-control'],
      name: SpecFieldNames.LINEAR_METERS,
      dataTId: SpecFieldTestIds.LINEAR_METERS,
      min: 0,
      value: 0,
      step: 1,
      hidden: true,
      onChange: [HandleLinearMeterChangeCommand],
    } as FieldInputNumberConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.application',
      name: SpecFieldNames.APPLICATION,
      dataTId: SpecFieldTestIds.APPLICATION,
      optionsLoader: ApplicationOptionLoader,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_application',
      validation: [Validators.required],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.spacing',
      name: SpecFieldNames.SPACING,
      dataTId: SpecFieldTestIds.SPACING,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_spacing',
      optionsLoader: SpacingOptionLoader,
      validation: [Validators.required],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.unloadTime',
      name: SpecFieldNames.DISCHARGE_TIME,
      dataTId: SpecFieldTestIds.UNLOAD_TIME,
      containerClassNames: ['field-12x field-md-3x retail-control'],
      placeholder: 'views.specifications.select_unloadTime',
      optionsLoader: UnloadTimeOptionLoader,
      validation: [Validators.required],
    } as FieldSelectConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormTextAreaComponent,
      label: 'views.specifications.additional_info',
      name: SpecFieldNames.ADDITIONAL_INFO,
      dataTId: SpecFieldTestIds.ADDITIONAL_INFO,
      containerClassNames: ['field-12x field-md-12x retail-control'],
      placeholder: 'views.specifications.enter_comment',
      maxlength: '63',
      validation: [],
    } as FieldConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormInputCheckboxComponent,
      name: SpecFieldNames.CLEAN_UP,
      dataTId: SpecFieldTestIds.CLEAN_UP,
      value: false,
      containerClassNames: ['field-12x field-md-12x retail-control'],
      placeholder: 'views.specifications.cleanUp',
      validation: [],
    } as FieldConfig,
  ],
  maxLinearMeters: 150,
} as RmsFormConfig;
